module.exports = __webpack_public_path__ + "img/analytics.8f7eadf0.png";